export default "__VITE_ASSET__WR_Cc49u__"